<template>
  <div id="container" class="mainBox">
    <div class="middle">
      <div class="biaoti">上蔡县</div>
    </div>
    <router-link :to="{ path: '/shangcaixq' }" class="daohLeftTop">
      <div class="daohLeftBox">
        <img class="img" src="../assets/img/newhome/sc@2x.png" />
        <h5 class="h5">上蔡县情简介</h5>
        <img class="imgs" src="../assets/img/newhome/z@2x.png" />
      </div>
    </router-link>
    <router-link :to="{ path: '/shangcaixq1' }" class="daohLeftBottom">
      <div class="daohLeftBox">
        <img class="img" src="../assets/img/newhome/cz@2x.png" />
        <h5 class="h5">上蔡县国家农村产业融合发展示范园</h5>
        <img class="imgs" src="../assets/img/newhome/z@2x.png" />
      </div>
    </router-link>
    <router-link :to="{ path: '/xianqing1' }" class="daohRightTop">
      <div class="daohLeftBox">
        <img class="imgs" src="../assets/img/newhome/y@2x.png" />
        <h5 class="h5">农业产业融合发展智慧管理体系</h5>
        <img class="img" src="../assets/img/newhome/cz@2x.png" />

      </div>
    </router-link>
    <div class="daohRightBottom" @click="clickHref" >
      <div class="daohLeftBox">
        <img class="imgs" src="../assets/img/newhome/y@2x.png" />
        <h5 class="h5">智慧农业管理服务平台</h5>
        <img class="img" src="../assets/img/newhome/gb@2x.png" />
      </div>
    </div>
  </div>
</template>

<script setup>
  function clickHref(){
        window.open( "http://hnyfwlw.com/#/login")
  }

</script>
<style lang="less" scoped>
.mainBox {
  width: 100%;
  height: 100%;
  background: url("../assets/img/newhome/bj2.jpg") no-repeat top center;
  background-size: 100% 100%;
  .middle {
    width: 1004px;
    height: 719px;
    background: url("../assets/img/newhome/zx@2x.png") no-repeat top center;
    background-size: 100% 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -502px;
    margin-top: -360px;
    .biaoti {
      width: 100%;
      height: 300px;
      font-size: 50px;
      color: #fff;
      text-align: center;
      line-height: 300px;
      letter-spacing: 1em;
      position: absolute;
      bottom: 100px;
      margin-left: 20px;
    }
  }

  .daohLeftTop,.daohLeftBottom{
      width: 1701px;
      height: 317px;
      position: absolute;
      left: 320px;
      text-decoration: none;
    }
  .daohLeftTop{
    top: 521px;
  }
  .daohLeftBottom{
    top: 990px;
  }

  .daohRightTop,.daohRightBottom{
    width: 1511px;
    height: 317px;
    position: absolute;
    right: 563px;
    cursor: pointer;
    text-decoration: none;
    .daohLeftBox{
      .h5{
        text-align: right;
        margin-right: 80px;
        margin-left: 0;
      }
    }
  }
  .daohRightTop{
    top: 521px;
  }
  .daohRightBottom{
    top: 990px;
  }

  .daohLeftBox{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .h5 {
      width: 1210px;
      color: #fff;
      font-size: 69px;
      margin-left: 80px;
      text-align: left;

    }
    .img {
      width: 339px;
      height: 317px;
    }

    .imgs {
      width: 50px;
      height: 50px;
    }
  }

  .daohLeftBox:hover  {
    .img {
      transition: all 1s ease-in-out; /* 添加过渡效果 */
      /* 设置初始状态 */
      transform: rotate(0deg) scale(1);
      animation: rotateAndZoom 2s linear forwards; /* 动画名称、持续时间、速度曲线和是否保持结束状态 */
    }
  }
}


@keyframes rotateAndZoom {
  0% {
    transform: rotate(0deg) scale(1); /* 开始时，不旋转且大小为原尺寸 */
  }
  50% {
    transform: rotate(360deg) scale(1); /* 在一半时间点上完成一次完整旋转 */
  }
  100% {
    transform: rotate(360deg) scale(1.1); /* 结束时，完成旋转并放大10% */
  }
}
</style>
